export interface LoginProvider {
    name: string;
    isActive: boolean;
    isExternal: boolean;
}

export enum ProviderType {
    EmailAndPassword = "EmailAndPassword",
    Google = "google.com",
}
